var _path, _path2, _g, _g2, _g3, _g4, _path3, _g5, _g6, _g7, _g8, _g9, _g10;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBuilding4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 669 148.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#454C53",
    d: "M266.5 41.8h36.8v98.4h-36.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M269 54.7h4v14h-4zM276 54.7h3v14h-3zM289 54.7h4v14h-4zM296 54.7h4v14h-4zM269 71.7h4v14h-4zM282 71.7h5v14h-5zM289 71.7h4v14h-4zM269 88.7h4v14h-4zM276 88.7h3v14h-3zM282 88.7h5v14h-5zM296 88.7h4v14h-4zM269 106.7h4v13h-4zM282 106.7h5v13h-5zM289 106.7h4v13h-4z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#454C53",
    d: "M141.5 33.1h35v107.1h-35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M169 47.7h3v15h-3zM169 66.7h3v15h-3zM169 84.7h3v16h-3zM169 103.7h3v16h-3zM161 47.7h3v15h-3zM161 66.7h3v15h-3zM161 103.7h3v16h-3zM153 47.7h3v15h-3zM153 84.7h3v16h-3zM153 103.7h3v16h-3zM145 47.7h3v15h-3zM145 66.7h3v15h-3zM145 84.7h3v16h-3zM145 103.7h3v16h-3z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#454C53",
    d: "M529.1 140.2V16.6L494.4 3.8v136.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M498.5 30.2h9.7v2h-9.7zM516.2 30.2h9.3v2h-9.3zM516.2 35.2h9.3v3h-9.3zM498.5 35.2h9.7v3h-9.7zM516.2 46.2h9.3v3h-9.3zM498.5 46.2h9.7v3h-9.7zM498.5 52.2h9.7v2h-9.7zM516.2 52.2h9.3v2h-9.3zM498.5 57.2h9.7v3h-9.7zM516.2 57.2h9.3v3h-9.3zM498.5 68.2h9.7v3h-9.7zM516.2 68.2h9.3v3h-9.3zM498.5 74.2h9.7v2h-9.7zM516.2 74.2h9.3v2h-9.3zM498.5 79.2h9.7v3h-9.7zM516.2 79.2h9.3v3h-9.3zM498.5 85.2h9.7v2h-9.7zM516.2 85.2h9.3v2h-9.3zM498.5 90.2h9.7v3h-9.7zM516.2 90.2h9.3v3h-9.3zM498.5 101.2h9.7v3h-9.7zM516.2 101.2h9.3v3h-9.3zM498.5 107.2h9.7v2h-9.7zM516.2 107.2h9.3v2h-9.3zM498.5 112.2h9.7v3h-9.7zM516.2 112.2h9.3v3h-9.3zM498.5 123.2h9.7v3h-9.7zM516.2 123.2h9.3v3h-9.3zM498.5 129.2h9.7v2h-9.7zM516.2 129.2h9.3v2h-9.3z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#454C53",
    d: "M214.5 18.5h46.8v123.7h-46.8z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250 32.7h5v6h-5zM250 41.7h5v6h-5zM250 50.7h5v7h-5zM250 59.7h5v7h-5zM250 68.7h5v7h-5zM250 78.7h5v6h-5zM250 96.7h5v6h-5zM250 114.7h5v7h-5zM250 123.7h5v7h-5zM240 32.7h5v6h-5zM240 41.7h5v6h-5zM240 59.7h5v7h-5zM240 78.7h5v6h-5zM240 87.7h5v6h-5zM240 96.7h5v6h-5zM240 105.7h5v6h-5zM240 123.7h5v7h-5zM230 32.7h5v6h-5zM230 41.7h5v6h-5zM230 50.7h5v7h-5zM230 59.7h5v7h-5zM230 68.7h5v7h-5zM230 78.7h5v6h-5zM230 96.7h5v6h-5zM230 105.7h5v6h-5zM230 114.7h5v7h-5zM220 32.7h5v6h-5zM220 41.7h5v6h-5zM220 59.7h5v7h-5zM220 78.7h5v6h-5zM220 87.7h5v6h-5zM220 105.7h5v6h-5zM220 123.7h5v7h-5z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#454C53",
    d: "M454.5 70.6h33v69.5h-33z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M472 78.7h4v4h-4zM472 84.7h4v5h-4zM472 91.7h4v4h-4zM472 97.7h4v5h-4zM472 103.7h4v5h-4zM472 110.7h4v4h-4zM472 116.7h4v5h-4zM472 123.7h4v4h-4zM465 78.7h4v4h-4zM465 84.7h4v5h-4zM465 91.7h4v4h-4zM465 97.7h4v5h-4zM465 103.7h4v5h-4zM465 110.7h4v4h-4zM465 116.7h4v5h-4zM465 123.7h4v4h-4z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#454C53",
    d: "M0 139.7h669v9H0z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#454C53",
    d: "M534.5 64.7h39v77.5h-39z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M537 79.7h5v8h-5zM552 79.7h4v8h-4zM567 79.7h3v8h-3zM537 89.7h5v8h-5zM552 89.7h4v8h-4zM559 89.7h4v8h-4zM567 89.7h3v8h-3zM537 98.7h5v7h-5zM545 98.7h4v7h-4zM552 98.7h4v7h-4zM567 98.7h3v7h-3zM552 107.7h4v8h-4zM559 107.7h4v8h-4zM537 116.7h5v9h-5zM545 116.7h4v9h-4zM552 116.7h4v9h-4zM559 116.7h4v9h-4zM567 116.7h3v9h-3zM537 126.7h5v8h-5zM552 126.7h4v8h-4zM567 126.7h3v8h-3z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#454C53",
    d: "M412.5 57.2h36v85h-36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M416.5 64.7h12v3h-12zM433.3 64.7h11.3v3h-11.3zM416.5 72.7h12v3h-12zM416.5 80.7h12v3h-12zM433.3 80.7h11.3v3h-11.3zM433.3 88.7h11.3v3h-11.3zM433.3 96.7h11.3v3h-11.3zM416.5 96.7h12v3h-12zM416.5 104.7h12v3h-12zM416.5 112.7h12v3h-12zM433.3 112.7h11.3v3h-11.3z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#454C53",
    d: "M309.4 64.7h36v81.5h-36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M333.6 79.2h7.2v3h-7.2zM324 87.2h6.7v3H324zM333.6 95.2h7.2v3h-7.2zM324 95.2h6.7v3H324zM333.6 103.2h7.2v3h-7.2zM324 103.2h6.7v3H324zM324 111.2h6.7v3H324zM333.6 119.2h7.2v3h-7.2zM324 119.2h6.7v3H324zM314.6 79.2h7.2v3h-7.2zM314.6 87.2h7.2v3h-7.2zM314.6 103.2h7.2v3h-7.2zM314.6 111.2h7.2v3h-7.2zM314.6 119.2h7.2v3h-7.2zM324 127.2h6.7v3H324z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "#454C53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.8 49.2c0-5.2-5.2-9.4-12-9.9v-2.7l-.1-6.4-.3-19.4h-2l-.3 19.4c-1.3.5-2.2 1.7-2.2 3.2 0 1.5.9 2.7 2.1 3.3v2.7c-6.8.5-12.4 4.8-12.4 9.9 0 3.9 3.3 7.3 7.3 8.9v86.5h12V58.1c5.1-1.6 7.9-5 7.9-8.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199 33.2c0-1.5-.9-2.8-2.2-3.4l.1 6.7c1.2-.6 2.1-1.8 2.1-3.3z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#454C53",
    d: "M119 61.7v-15h-4v15H99v83h36v-83h-16zm-11 58h-4v-12h4v12zm0-17h-4v-12h4v12zm0-17h-4v-12h4v12zm7 17h-4v-12h4v12zm7 17h-4v-12h4v12zm0-34h-4v-12h4v12zm7 34h-4v-12h4v12zm0-17h-4v-12h4v12zm0-17h-4v-12h4v12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M104 73.7h4v12h-4zM118 73.7h4v12h-4zM125 73.7h4v12h-4zM104 90.7h4v12h-4zM111 90.7h4v12h-4zM125 90.7h4v12h-4zM104 107.7h4v12h-4zM118 107.7h4v12h-4zM125 107.7h4v12h-4z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M366.8 109.7l-1.3 10h26.2l-1.2-10z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#454C53",
    d: "M396.4 104.7h1.6v-8h-3.9l-9.2-44h2.1v-8h-3.8L380 31V8.7h-4V31l-2.2 13.6H369v8h3.1l-9.2 44H357v8h3.6l-12.6 37h13.2l1.4-.5 2.3-17.5h27.2l2.1 17.5 1.4.5H409l-12.6-36.9zm-16.6-52l4.7 22h-11.8l4.5-22h2.6zm-7.9 26h13.5l3.9 18h-21.1l3.7-18zm-6.4 41l1.3-10h23.7l1.2 10h-26.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M385.4 78.7h-13.5l-3.7 18h21.1zM384.5 74.7l-4.7-22h-2.5l-4.6 22z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding4);
export default __webpack_public_path__ + "static/media/building4.70144de364fa212e6973d7ba6fd8fde5.svg";
export { ForwardRef as ReactComponent };